import {Types} from 'mongoose';
import * as consts from './payamnets.const';

export const SESSION_FEE = {...consts.SESSION_FEE, _id: new Types.ObjectId('65f062bc2d71dfb4e188010b')};
export const OTHER_FEE = {...consts.OTHER_FEE, _id: new Types.ObjectId(consts.PAYMENT_TYPE_OTHER_ID)};
export const TRAINING_FEE = {...consts.TRAINING_FEE, _id: new Types.ObjectId('65f062bc2d71dfb4e188012b')};
export const GRANT_AWARD = {...consts.GRANT_AWARD, _id: new Types.ObjectId('65f062bc2d71dfb4e188013b')};
export const DONATION = {...consts.DONATION, _id: new Types.ObjectId('65f062bc2d71dfb4e188014b')};
export const FACILITATION_FEE = {...consts.FACILITATION_FEE, _id: new Types.ObjectId('65f062bc2d71dfb4e188015b')};
export const TRAINER_PAYMENT = {...consts.TRAINER_PAYMENT, _id: new Types.ObjectId('65f062bc2d71dfb4e188016b')};
export const COACH_PAYMENT = {...consts.COACH_PAYMENT, _id: new Types.ObjectId('65f062bc2d71dfb4e188017b')};
export const MEDIATOR_PAYMENT = {...consts.MEDIATOR_PAYMENT, _id: new Types.ObjectId('65f062bc2d71dfb4e188018b')};
export const FC_KEEPER_PAYMENT = {...consts.FC_KEEPER_PAYMENT, _id: new Types.ObjectId('65f062bc2d71dfb4e188019b')};
